import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Row } from 'reactstrap';
import { get } from 'lodash';
import { TbReportMoney, TbSteeringWheel, TbSteeringWheelOff } from 'react-icons/tb';
import { MdOutlineSsidChart } from 'react-icons/md';
import ComponentCard from '../../common/components/cards/ComponentCard';
import DetailedSnapshotCard from './DetailedSnapshotCard';
import { getTodayDate } from '../../common/utils/date/Date.utils';
import { fetchSaleStatistics } from '../DashboardActions';
import { deltaGrowth, mapDelta } from '../utils/delta';

function SaleOverviewSection() {
  const dispatch = useDispatch();
  const saleStatistics = useSelector((state) => state.dashboard.get('saleStatistics'));

  const today = getTodayDate();

  const [dataInitialized, setDataInitialized] = useState(false);

  const [soldVehiclesRangeStart, setSoldVehiclesRangeStart] = useState(today);
  const [soldVehiclesRangeEnd, setSoldVehiclesRangeEnd] = useState(today);

  const [totalSalesRangeStart, setTotalSalesRangeStart] = useState(today);
  const [totalSalesRangeEnd, setTotalSalesRangeEnd] = useState(today);

  const [salesVersusCapRangeStart, setSalesVersusCapRangeStart] = useState(today);
  const [salesVersusCapRangeEnd, setSalesVersusCapRangeEnd] = useState(today);

  const [auctionsWithNoSaleRangeStart, setAuctionsWithNoSaleRangeStart] = useState(today);
  const [auctionsWithNoSaleRangeEnd, setAuctionsWithNoSaleRangeEnd] = useState(today);

  useEffect(() => {
    if (!dataInitialized) {
      setDataInitialized(true);
      return;
    }
    dispatch(
      fetchSaleStatistics({
        soldVehiclesRangeStart,
        soldVehiclesRangeEnd,
        totalSalesRangeStart,
        totalSalesRangeEnd,
        salesVersusCapRangeStart,
        salesVersusCapRangeEnd,
        auctionsWithNoSaleRangeStart,
        auctionsWithNoSaleRangeEnd,
      }),
    );
  }, [
    soldVehiclesRangeStart,
    soldVehiclesRangeEnd,
    totalSalesRangeStart,
    totalSalesRangeEnd,
    salesVersusCapRangeStart,
    salesVersusCapRangeEnd,
    auctionsWithNoSaleRangeStart,
    auctionsWithNoSaleRangeEnd,
  ]);

  return (
    <ComponentCard title="Sale Overview" isCollapsible>
      <Row className="dashboard__snapshot-detailed-row">
        <DetailedSnapshotCard
          title="Vehicles Sold"
          value={get(saleStatistics, 'soldVehicles', 0)}
          variant="success"
          icon={<TbSteeringWheel />}
          showDatePicker
          datePickerStartValue={soldVehiclesRangeStart}
          datePickerEndValue={soldVehiclesRangeEnd}
          setDatePickerStartValue={setSoldVehiclesRangeStart}
          setDatePickerEndValue={setSoldVehiclesRangeEnd}
          defaultDatePickerStartValue={today}
          defaultDatePickerEndValue={today}
          datePickerStartPlaceholder="Today"
          showDateComparison={false}
        />
        <DetailedSnapshotCard
          title="Total Sales Value"
          prefix="£"
          counterDecimals={2}
          value={get(saleStatistics, 'totalSalesValue', 0)}
          variant="secondary"
          icon={<TbReportMoney />}
          showDatePicker
          datePickerStartValue={totalSalesRangeStart}
          datePickerEndValue={totalSalesRangeEnd}
          setDatePickerStartValue={setTotalSalesRangeStart}
          setDatePickerEndValue={setTotalSalesRangeEnd}
          defaultDatePickerStartValue={today}
          defaultDatePickerEndValue={today}
          datePickerStartPlaceholder="Today"
          showDateComparison={false}
        />
        <DetailedSnapshotCard
          title="Sales vs CAP"
          prefix={`${get(saleStatistics, 'salesVersusCap', 0) > 0 ? '+' : ''}£`}
          counterDecimals={2}
          value={get(saleStatistics, 'salesVersusCap', 0)}
          variant="danger"
          icon={<MdOutlineSsidChart />}
          deltaGrowth={deltaGrowth(get(saleStatistics, 'salesVersusCapDelta', 0))}
          delta={mapDelta(get(saleStatistics, 'salesVersusCapDelta', 0))}
          showDatePicker
          datePickerStartValue={salesVersusCapRangeStart}
          datePickerEndValue={salesVersusCapRangeEnd}
          setDatePickerStartValue={setSalesVersusCapRangeStart}
          setDatePickerEndValue={setSalesVersusCapRangeEnd}
          defaultDatePickerStartValue={today}
          defaultDatePickerEndValue={today}
          datePickerStartPlaceholder="Today"
          showDateComparison={false}
        />
        <DetailedSnapshotCard
          title="Auctions w/ No Sale"
          value={get(saleStatistics, 'auctionsWithNoSale', 0)}
          variant="warning"
          icon={<TbSteeringWheelOff />}
          showDatePicker
          datePickerStartValue={auctionsWithNoSaleRangeStart}
          datePickerEndValue={auctionsWithNoSaleRangeEnd}
          setDatePickerStartValue={setAuctionsWithNoSaleRangeStart}
          setDatePickerEndValue={setAuctionsWithNoSaleRangeEnd}
          defaultDatePickerStartValue={today}
          defaultDatePickerEndValue={today}
          datePickerStartPlaceholder="Today"
          showDateComparison={false}
        />
      </Row>
    </ComponentCard>
  );
}

export default SaleOverviewSection;
